import { MANUAL_ADD_DEVICE as manualAddDevice } from './manualAddDevice';
import { MANUAL_EDIT_DEVICE as manualEditDevice } from './manualEditDevice';

export const DEVICES = { manualAddDevice, manualEditDevice };
